import React from "react";
import ReactDOM from "react-dom/client";
import "react-day-picker/dist/style.css"; // Import BEFORE index.css so our overrides work
import "@fortawesome/fontawesome-free/css/all.min.css"; // Icônes Font Awesome (catalogue prêt, etc.)
import App from "./AppComplete.tsx";
import "./index.css";
/* FAQ HTML riche : feuille Quill globale (alignement, tailles, listes, etc.) — évite un ordre de chunks où le CSS ne serait pas appliqué */
import "quill/dist/quill.snow.css";
import "./i18n";
import { enableFetchInterceptor } from "@/shared/lib/apiInterceptor";

enableFetchInterceptor();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
